/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getReviewsByDeviceResponseDataSchema = z.object({
  watch: z.number().int(),
  iphone: z.number().int(),
  ipad: z.number().int(),
  web: z.number().int(),
  android: z.number().int(),
});

export type IGetReviewsByDeviceResponseData = z.infer<typeof getReviewsByDeviceResponseDataSchema>;

export const getReviewsByDeviceResponseSchema = createApiResponseSchema(
  getReviewsByDeviceResponseDataSchema,
) as z.ZodSchema<IAPI<IGetReviewsByDeviceResponseData>>;

export type IGetReviewsByDeviceResponse = IAPI<IGetReviewsByDeviceResponseData>;
